import { Analytics } from '@cobliteam/analytics';
import { RuleCategory } from '@cobliteam/api-lib/src/dashboard/alerts/definitions/rules';
import { Location, type UUID } from '@cobliteam/common-types';
import { useTranslation } from '@cobliteam/i18n';
import { Button } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import queryString from 'query-string';
import type React from 'react';
import { Link } from 'react-router-dom';

import type { ProcessedStopRouteStep } from '../../../../store';
import { StopPopup } from '../../../StopPopup/StopPopup';

export interface HistoryStopPopupProps {
  stop: ProcessedStopRouteStep;
  vehicleId: UUID;
  idleTimeHighlighted: boolean;
  filteredDuration?: number;
}

export const HistoryStopPopup: React.FC<HistoryStopPopupProps> = ({ stop, vehicleId, idleTimeHighlighted, filteredDuration }) => {
  const { t } = useTranslation('tracking');

  const handleCheckMap = () => {
    Analytics.track('Opened Vehicle Tracking On Map From Tracking History Stop Popup');

    const params = queryString.stringify({
      vehicle_id: vehicleId,
      date: stop.startTime,
      event_type: 'stop',
      event_step: stop.index + 1,
    });
    const url = `${window.location.origin}/#${Location.TRACKING}?${params}`;
    window.open(url, '_blank')!.focus();
  };

  return (
    <StopPopup stop={stop} filteredDuration={filteredDuration} idleTimeHighlighted={idleTimeHighlighted}>
      <Link
        className='flex-1'
        to={{
          pathname: Location.ALERTS_TRIGGERS_CREATE,
          search: queryString.stringify({
            templateRule: RuleCategory.IDLE_ENGINE,
          }),
        }}
      >
        <Button variant='outlined' size='sm' className='w-full' startIcon={<Icon name='plus' />} onClick={() => Analytics.track('Created Idle Engine Rule by Hook Popup')}>
          {t('create_idle_engine_rule')}
        </Button>
      </Link>
      <Button variant='ghost' className='w-full flex-1' size='sm' startIcon={<Icon name='external-link' />} onClick={handleCheckMap}>
        {t('check_map')}
      </Button>
    </StopPopup>
  );
};
